import store from '@/store'
import { Message } from 'view-design'

/**
 * 检查是否有权限
 * @param {*} id
 */
export function checkBtnPermission(id) {
  if (id && id.length > 0) {
    const roles = store.getters['menu/getBUTTONS']
    const permissionRoles = id
    if (roles.indexOf(permissionRoles) > -1) {
      return true
    }
    return false
  } else {
    return false
  }
}
// 获取多少天后日期 获取多少天前日期
export function formatDate(num) {
  var now = new Date()
  var nowTime = now.getTime()
  var oneDayTime = 24 * 60 * 60 * 1000
  var ShowTime = nowTime + num * oneDayTime
  var myDate = new Date(ShowTime)
  var y = myDate.getFullYear()// 年
  var m = myDate.getMonth() + 1// 月
  var d = myDate.getDate()// 日
  return formatDateYMD([y, m, d].map(padStartConvert).join('-'))
}

export function padStartConvert(n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

export function formatDateYMD(date, format) {
  if (!date) return
  if (!format) format = 'yyyy-MM-dd'
  switch (typeof date) {
    case 'string':
      date = new Date(date.replace(/-/, '/'))
      break
    case 'number':
      date = new Date(date)
      break
  }
  if (!(date instanceof Date)) return
  var dict = {
    'yyyy': date.getFullYear(),
    'M': date.getMonth() + 1,
    'd': date.getDate(),
    'H': date.getHours(),
    'm': date.getMinutes(),
    's': date.getSeconds(),
    'MM': ('' + (date.getMonth() + 101)).substr(1),
    'dd': ('' + (date.getDate() + 100)).substr(1),
    'HH': ('' + (date.getHours() + 100)).substr(1),
    'mm': ('' + (date.getMinutes() + 100)).substr(1),
    'ss': ('' + (date.getSeconds() + 100)).substr(1)
  }
  return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function() {
    return dict[arguments[0]]
  })
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function notify() {
  Message.info({
    content: '正在开发中。。。。。。敬请期待！',
    duration: 2
  })
}

export function showAlert(text) {
  Message.info({
    content:text,
    duration: 2
  })
}
export function formatDateTime(dateTimeStr) {
  if (!dateTimeStr) return '';
  return dateTimeStr.replace('T', ' ');
}
